import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maparray',
    standalone: false,
})
export class ArrayAttrMapPipe implements PipeTransform {
    transform(array: any[], attrName: any): any[] {
        return array?.map((item) => item[attrName]);
    }
}
